import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegisterService } from '../../account/register/register.service';
import { LoginService } from '../../core/login/login.service';
import { AccountService } from '../../core/auth/account.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../account/register/register.service";
import * as i4 from "../../core/login/login.service";
import * as i5 from "../../core/auth/account.service";
import * as i6 from "../../shared/language/language-selector/language-selector.component";
import * as i7 from "../../shared/support/support-dropdown.component";
import * as i8 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i9 from "@angular/forms";
import * as i10 from "@fortawesome/angular-fontawesome";
import * as i11 from "@angular/common";
import * as i12 from "../../shared/password-strength-meter/password-strength-meter.component";
import * as i13 from "../../shared/consent-text/consent-text.component";
import * as i14 from "@ngx-translate/core";
const _c0 = ["registerAlertModal"];
function RegisterDemoComponent_div_20_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 19);
} }
function RegisterDemoComponent_div_20_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 49);
} }
function RegisterDemoComponent_div_20_fa_icon_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 19);
} }
function RegisterDemoComponent_div_20_fa_icon_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 49);
} }
function RegisterDemoComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelementStart(1, "div", 42);
    i0.ɵɵelementStart(2, "p", 18);
    i0.ɵɵtemplate(3, RegisterDemoComponent_div_20_fa_icon_3_Template, 1, 0, "fa-icon", 43);
    i0.ɵɵtemplate(4, RegisterDemoComponent_div_20_fa_icon_4_Template, 1, 0, "fa-icon", 44);
    i0.ɵɵelement(5, "span", 45);
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 46);
    i0.ɵɵelementStart(8, "p", 47);
    i0.ɵɵtemplate(9, RegisterDemoComponent_div_20_fa_icon_9_Template, 1, 0, "fa-icon", 43);
    i0.ɵɵtemplate(10, RegisterDemoComponent_div_20_fa_icon_10_Template, 1, 0, "fa-icon", 44);
    i0.ɵɵelement(11, "span", 48);
    i0.ɵɵelement(12, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.isLetterNumber);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isLetterNumber);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.isMax20);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isMax20);
} }
function RegisterDemoComponent_fa_icon_36_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 50);
    i0.ɵɵlistener("click", function RegisterDemoComponent_fa_icon_36_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.onTogglePassword(ctx_r11.TYPE_PASSWORD); });
    i0.ɵɵelementEnd();
} }
function RegisterDemoComponent_fa_icon_37_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 51);
    i0.ɵɵlistener("click", function RegisterDemoComponent_fa_icon_37_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.onTogglePassword(ctx_r13.TYPE_PASSWORD); });
    i0.ɵɵelementEnd();
} }
function RegisterDemoComponent_fa_icon_43_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 50);
    i0.ɵɵlistener("click", function RegisterDemoComponent_fa_icon_43_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.onTogglePassword(ctx_r15.TYPE_CONFIRM); });
    i0.ɵɵelementEnd();
} }
function RegisterDemoComponent_fa_icon_44_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fa-icon", 51);
    i0.ɵɵlistener("click", function RegisterDemoComponent_fa_icon_44_Template_fa_icon_click_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.onTogglePassword(ctx_r17.TYPE_CONFIRM); });
    i0.ɵɵelementEnd();
} }
function RegisterDemoComponent_div_45_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 19);
} }
function RegisterDemoComponent_div_45_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 49);
} }
function RegisterDemoComponent_div_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelementStart(1, "div", 42);
    i0.ɵɵelementStart(2, "p", 18);
    i0.ɵɵtemplate(3, RegisterDemoComponent_div_45_fa_icon_3_Template, 1, 0, "fa-icon", 43);
    i0.ɵɵtemplate(4, RegisterDemoComponent_div_45_fa_icon_4_Template, 1, 0, "fa-icon", 44);
    i0.ɵɵelement(5, "span", 52);
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r6.passwordsMatch);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.passwordsMatch);
} }
export class RegisterDemoComponent {
    constructor(activatedRoute, ngbModal, registerService, loginService, accountService, elementRef, router) {
        this.activatedRoute = activatedRoute;
        this.ngbModal = ngbModal;
        this.registerService = registerService;
        this.loginService = loginService;
        this.accountService = accountService;
        this.elementRef = elementRef;
        this.router = router;
        this.generatedUsername = '';
        this.isLetterNumber = true;
        this.isMax20 = true;
        this.isMin8 = false;
        this.passwordsMatch = true;
        this.toggle = '';
        this.focusClass = 'mb-2';
        this.TOGGLE_USERNAME = 'TOGGLE_USERNAME';
        this.TOGGLE_PASSWORD = 'TOGGLE_PASSWORD';
        this.TOGGLE_CONFIRM = 'TOGGLE_CONFIRM';
        this.passwordTypeInput = 'password';
        this.confirmTypeInput = 'password';
        this.passwordEyeSlashed = false;
        this.confirmEyeSlashed = false;
        this.TYPE_PASSWORD = 'TYPE_PASSWORD';
        this.TYPE_CONFIRM = 'TYPE_CONFIRM';
        this.DEMO = 'Demo';
        this.specialCharacters = new RegExp('^[a-zA-Z0-9]+$');
        this.pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        this.isUsed = false;
        this.consents = [];
    }
    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#FFFFFF';
        if (this.accountService.isAuthenticated()) {
            this.loginService.redirectToHomepage();
        }
        this.generateUsername();
    }
    generateUsername() {
        this.generateUsernameSubscription = this.registerService.generateUsername().subscribe(response => (this.generatedUsername = response));
    }
    onRegister(form) {
        console.log(form.value);
        let login = form.value.login;
        let email = form.value.email.trim();
        let password = form.value.password.trim();
        let confirmPassword = form.value.confirmPassword.trim();
        let voucherCode = form.value.voucherCode;
        let country = this.DEMO;
        let checkbox = form.value.checkbox;
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (login.length === 0) {
            this.registerService.openAlertModal('register.messages.error.usernameRequired');
            return;
        }
        if (login.length > 20) {
            this.registerService.openAlertModal('register.messages.error.usernameMaxTwenty');
            return;
        }
        if (!this.specialCharacters.test(login)) {
            this.registerService.openAlertModal('register.messages.error.numberLetterOnly');
            return;
        }
        if (email.length === 0) {
            this.registerService.openAlertModal('register.messages.error.emailRequired');
            return;
        }
        if (!this.pattern.test(email)) {
            this.registerService.openAlertModal('register.messages.error.invalidEmail');
            return;
        }
        if (password.length < 8) {
            this.registerService.openAlertModal('register.messages.error.atLeast8');
            return;
        }
        if (confirmPassword !== password) {
            this.registerService.openAlertModal('register.messages.error.doNotMatch');
            return;
        }
        // if (!this.specialCharacters.test(password)) {
        //   this.registerService.openAlertModal('register.messages.error.numberLetterOnlyPassword');
        //   return;
        // }
        if (!checkbox) {
            this.registerService.openAlertModal('register.messages.error.agreeTerms');
            return;
        }
        let registrationData = { login, email, password, voucherCode, country, timezone, consents: this.consents };
        this.registrationSubscription = this.registerService.save(registrationData).subscribe(response => {
            if (response === "Voucher code doesn't exist!") {
                this.registerService.openAlertModal('register.messages.error.noVoucherCode');
                return;
            }
            if (response === 'There are no more usages left for the voucher code!') {
                this.registerService.openAlertModal('register.messages.error.noUsageVoucherCode');
                return;
            }
            if (response === 'Voucher code expired!') {
                this.registerService.openAlertModal('register.messages.error.voucherCodeExpired');
                return;
            }
            if (response === "Voucher code doesn't run!") {
                this.registerService.openAlertModal('register.messages.error.noRunVoucherCode');
                return;
            }
            if (response === 'OK') {
                let request = { email, password, rememberMe: true };
                this.loginSubscription = this.loginService.login(request).subscribe(() => {
                    this.router.navigate(['/onboarding']).then();
                }, error => console.log(error));
            }
        }, response => {
            let errorKey = JSON.parse(response.error).errorKey;
            if (errorKey === 'userexists' || errorKey === 'emailexists') {
                this.isUsed = true;
                this.registerService.openAlertModal('register.messages.error.' + errorKey);
                return;
            }
        });
    }
    modalNavigate(url) {
        this.router.navigate([url]).then(response => console.log(response));
    }
    focusInOut(toggleField, focusIn) {
        this.toggle = focusIn ? toggleField : '';
        console.log(this.toggle);
        this.focusClass = focusIn ? 'mb-2' : '';
        console.log(this.focusClass);
    }
    passwordCheck(form) {
        let firstPassword = form.value.password.trim();
        let confirmPassword = form.value.confirmPassword.trim();
        this.isMin8 = firstPassword.length >= 8;
        this.passwordsMatch = firstPassword === confirmPassword;
    }
    onTogglePassword(type) {
        if (type === this.TYPE_PASSWORD) {
            this.passwordEyeSlashed = !this.passwordEyeSlashed;
            this.passwordTypeInput === 'text' ? (this.passwordTypeInput = 'password') : (this.passwordTypeInput = 'text');
        }
        else if (type === this.TYPE_CONFIRM) {
            this.confirmEyeSlashed = !this.confirmEyeSlashed;
            this.confirmTypeInput === 'text' ? (this.confirmTypeInput = 'password') : (this.confirmTypeInput = 'text');
        }
    }
    updateConsents(consent) {
        this.consents = this.consents.filter(c => c.name !== consent.name);
        this.consents.push(consent);
    }
    setPasswordText(form) {
        this.passwordText = form.value.password.trim();
    }
    ngOnDestroy() {
        if (this.registrationSubscription) {
            this.registrationSubscription.unsubscribe();
        }
        if (this.loginSubscription) {
            this.loginSubscription.unsubscribe();
        }
        if (this.generateUsernameSubscription) {
            this.generateUsernameSubscription.unsubscribe();
        }
    }
}
RegisterDemoComponent.ɵfac = function RegisterDemoComponent_Factory(t) { return new (t || RegisterDemoComponent)(i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.RegisterService), i0.ɵɵdirectiveInject(i4.LoginService), i0.ɵɵdirectiveInject(i5.AccountService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.Router)); };
RegisterDemoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RegisterDemoComponent, selectors: [["register-demo"]], viewQuery: function RegisterDemoComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.registerAlertModal = _t.first);
    } }, decls: 57, vars: 36, consts: [[1, "navbar", "navbar-dark", "d-flex", "justify-content-end"], [1, "row"], [1, "float-right", "pl-2", "pr-2"], [1, "page", 2, "background-color", "white"], [1, "page-single", 2, "background-color", "white", "border-radius", "20px"], [1, "container-fluid"], [1, "row", "fadeIn", "animated"], [1, "offset-sm-2", "col-sm-8", "offset-md-3", "col-md-6", "offset-lg-3", "col-lg-6", "offset-xl-4", "col-xl-4"], ["id", "inuka-header-default", 1, "mt-4"], ["jhiTranslate", "register.header.signUp", 1, "m-2", 2, "font-weight", "bold", "text-align", "center", "text-transform", "uppercase", "color", "#44A38D"], [3, "ngSubmit"], ["registrationForm", "ngForm"], ["id", "username-div", 2, "position", "relative"], ["type", "text", "id", "username", "name", "login", "required", "", 1, "form-control", 2, "border-radius", "6px", 3, "ngModel", "placeholder", "ngModelChange", "focusin", "focusout"], ["icon", "undo", 1, "undo", 3, "click"], ["class", "row mt-2", 4, "ngIf"], [1, "row", "mb-2"], [1, "col-12", 2, "float", "left", "padding", "0 10px 0 20px"], [2, "float", "left", "margin-bottom", "0!important"], ["icon", "check", 1, "check"], ["jhiTranslate", "register.paragraph.confidentialIdentity", 1, "indicator-text"], [1, "form-group", "mb-2"], ["type", "text", "id", "email", "name", "email", "ngModel", "", "required", "", 1, "form-control", 3, "placeholder"], ["type", "text", "id", "voucher-code", "name", "voucherCode", "ngModel", "", "required", "", 1, "form-control", 3, "placeholder"], ["id", "new-password-div", 1, "form-group", "mb-2", 2, "position", "relative"], ["id", "new-password", "name", "password", "ngModel", "", "required", "", 2, "border-radius", "6px", "z-index", "10", 3, "type", "placeholder", "focusin", "focusout", "ngModelChange"], ["class", "eye", "icon", "eye", 3, "click", 4, "ngIf"], ["class", "eye", "icon", "eye-slash", 3, "click", 4, "ngIf"], [3, "password"], ["id", "confirmed-new-password-div", 1, "form-group", "mb-2", 2, "position", "relative"], ["id", "confirmed-new-password", "name", "confirmPassword", "ngModel", "", "required", "", 2, "border-radius", "6px", "z-index", "10", 3, "type", "placeholder", "focusin", "focusout", "keyup"], [1, "row", "mt-2", "mb-3", 2, "padding-left", "18px"], [1, "form-group", "col-1", 2, "padding-right", "0!important"], ["id", "confirm-checkbox", "type", "checkbox", "ngModel", "", "name", "checkbox", "required", "", 1, "form-control", "customcheck", "checkmark", "mb-2", 2, "color", "#44A38D"], [1, "col-11", 2, "font-size", "12px", "padding", "0!important"], ["name", "inuka-terms", 3, "onChange"], ["id", "registrationError", 1, "col-12"], [1, "col-12"], ["id", "sign-me-up-button", "type", "submit", "jhiTranslate", "register.button.signMeUp", 1, "btn", "btn-gradient-primary", "btn-block", "font-weight-bold"], [2, "margin", "10px"], ["jhiTranslate", "register.paragraph.haveAccount", 2, "text-align", "center", "margin-bottom", "0"], [1, "row", "mt-2"], [1, "col-6", 2, "float", "left", "padding", "0 10px 0 20px"], ["class", "check", "icon", "check", 4, "ngIf"], ["class", "times", "icon", "times", 4, "ngIf"], ["jhiTranslate", "register.paragraph.lettersNumbers", 1, "indicator-text"], [1, "col-6", 2, "padding", "0 10px 0 10px"], [2, "text-align", "center", "margin-bottom", "0!important"], ["jhiTranslate", "register.paragraph.maxChar", 1, "indicator-text"], ["icon", "times", 1, "times"], ["icon", "eye", 1, "eye", 3, "click"], ["icon", "eye-slash", 1, "eye", 3, "click"], ["jhiTranslate", "register.paragraph.passwordsMatch", 1, "indicator-text", 2, "padding-left", "3px"]], template: function RegisterDemoComponent_Template(rf, ctx) { if (rf & 1) {
        const _r21 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "nav", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "language-selector");
        i0.ɵɵelement(3, "support-dropdown", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelement(9, "br");
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵelement(11, "h3", 9);
        i0.ɵɵelement(12, "br");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(13, "br");
        i0.ɵɵelementStart(14, "form", 10, 11);
        i0.ɵɵlistener("ngSubmit", function RegisterDemoComponent_Template_form_ngSubmit_14_listener() { i0.ɵɵrestoreView(_r21); const _r0 = i0.ɵɵreference(15); return ctx.onRegister(_r0); });
        i0.ɵɵelementStart(16, "div", 12);
        i0.ɵɵelementStart(17, "input", 13);
        i0.ɵɵlistener("ngModelChange", function RegisterDemoComponent_Template_input_ngModelChange_17_listener($event) { return ctx.generatedUsername = $event; })("focusin", function RegisterDemoComponent_Template_input_focusin_17_listener() { return ctx.focusInOut(ctx.TOGGLE_USERNAME, true); })("focusout", function RegisterDemoComponent_Template_input_focusout_17_listener() { return ctx.focusInOut(ctx.TOGGLE_USERNAME, false); });
        i0.ɵɵpipe(18, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "fa-icon", 14);
        i0.ɵɵlistener("click", function RegisterDemoComponent_Template_fa_icon_click_19_listener() { return ctx.generateUsername(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(20, RegisterDemoComponent_div_20_Template, 13, 4, "div", 15);
        i0.ɵɵelementStart(21, "div", 16);
        i0.ɵɵelementStart(22, "div", 17);
        i0.ɵɵelementStart(23, "p", 18);
        i0.ɵɵelement(24, "fa-icon", 19);
        i0.ɵɵelement(25, "span", 20);
        i0.ɵɵelement(26, "br");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 21);
        i0.ɵɵelement(28, "input", 22);
        i0.ɵɵpipe(29, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 21);
        i0.ɵɵelement(31, "input", 23);
        i0.ɵɵpipe(32, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 24);
        i0.ɵɵelementStart(34, "input", 25);
        i0.ɵɵlistener("focusin", function RegisterDemoComponent_Template_input_focusin_34_listener() { ctx.focusInOut(ctx.TOGGLE_PASSWORD, true); return ctx.showPasswordMeter = true; })("focusout", function RegisterDemoComponent_Template_input_focusout_34_listener() { ctx.focusInOut(ctx.TOGGLE_PASSWORD, false); return ctx.showPasswordMeter = false; })("ngModelChange", function RegisterDemoComponent_Template_input_ngModelChange_34_listener() { i0.ɵɵrestoreView(_r21); const _r0 = i0.ɵɵreference(15); ctx.passwordCheck(_r0); return ctx.setPasswordText(_r0); });
        i0.ɵɵpipe(35, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(36, RegisterDemoComponent_fa_icon_36_Template, 1, 0, "fa-icon", 26);
        i0.ɵɵtemplate(37, RegisterDemoComponent_fa_icon_37_Template, 1, 0, "fa-icon", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div");
        i0.ɵɵelement(39, "password-strength-meter-component", 28);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(40, "div", 29);
        i0.ɵɵelementStart(41, "input", 30);
        i0.ɵɵlistener("focusin", function RegisterDemoComponent_Template_input_focusin_41_listener() { return ctx.focusInOut(ctx.TOGGLE_CONFIRM, true); })("focusout", function RegisterDemoComponent_Template_input_focusout_41_listener() { return ctx.focusInOut(ctx.TOGGLE_CONFIRM, false); })("keyup", function RegisterDemoComponent_Template_input_keyup_41_listener() { i0.ɵɵrestoreView(_r21); const _r0 = i0.ɵɵreference(15); return ctx.passwordCheck(_r0); });
        i0.ɵɵpipe(42, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(43, RegisterDemoComponent_fa_icon_43_Template, 1, 0, "fa-icon", 26);
        i0.ɵɵtemplate(44, RegisterDemoComponent_fa_icon_44_Template, 1, 0, "fa-icon", 27);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(45, RegisterDemoComponent_div_45_Template, 7, 2, "div", 15);
        i0.ɵɵelementStart(46, "div", 31);
        i0.ɵɵelementStart(47, "div", 32);
        i0.ɵɵelement(48, "input", 33);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(49, "div", 34);
        i0.ɵɵelementStart(50, "consent-text", 35);
        i0.ɵɵlistener("onChange", function RegisterDemoComponent_Template_consent_text_onChange_50_listener($event) { return ctx.updateConsents($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(51, "div", 1);
        i0.ɵɵelement(52, "div", 36);
        i0.ɵɵelementStart(53, "div", 37);
        i0.ɵɵelement(54, "button", 38);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(55, "hr", 39);
        i0.ɵɵelement(56, "p", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(16);
        i0.ɵɵclassMapInterpolate1("form-group ", ctx.focusClass, "");
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(18, 26, "register.placeholder.username"));
        i0.ɵɵproperty("ngModel", ctx.generatedUsername);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.toggle === ctx.TOGGLE_USERNAME);
        i0.ɵɵadvance(8);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(29, 28, "register.placeholder.email"));
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(32, 30, "register.placeholder.voucherCode"));
        i0.ɵɵadvance(3);
        i0.ɵɵclassMapInterpolate1("form-control ", ctx.focusClass, "");
        i0.ɵɵpropertyInterpolate("type", ctx.passwordTypeInput);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(35, 32, "register.placeholder.password"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.passwordEyeSlashed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.passwordEyeSlashed);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMap(ctx.showPasswordMeter ? "" : "d-none");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("password", ctx.passwordText);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMapInterpolate1("form-control ", ctx.focusClass, "");
        i0.ɵɵpropertyInterpolate("type", ctx.confirmTypeInput);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(42, 34, "register.placeholder.repeatPassword"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.confirmEyeSlashed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.confirmEyeSlashed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.toggle === ctx.TOGGLE_CONFIRM);
    } }, directives: [i2.NgbNavbar, i6.LanguageSelectorComponent, i7.SupportDropdownComponent, i8.JhiTranslateDirective, i9.ɵNgNoValidate, i9.NgControlStatusGroup, i9.NgForm, i9.DefaultValueAccessor, i9.RequiredValidator, i9.NgControlStatus, i9.NgModel, i10.FaIconComponent, i11.NgIf, i12.PasswordStrengthMeterComponent, i9.CheckboxControlValueAccessor, i9.CheckboxRequiredValidator, i13.ConsentTextComponent], pipes: [i14.TranslatePipe], styles: [".consent-text[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif;font-style:normal;font-size:11px;line-height:140% !important;color:#0a4a3a}"] });
